import React from "react";
import Image from "next/image";
import CustomBtn from "../btn/buttonCustom/index";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
function Team({ allTeam }) {
  const { locale } = useRouter();
  const t = useTranslations("aboutUs.team");
  const limitTeamMap = allTeam.map((element, index) => {
    const name = element.name;
    return (
      <div
        key={element._id}
        className={`h-auto mds:h-[240px] z-20 py-1 m-[25px] max-w-[274px] w-[100%] border-[3px] border-white rounded-lg ${
          index == 0
            ? "xlg:block  hidden "
            : index == 1
            ? "lg:block hidden "
            : "block"
        } 
     
        limitTeam  `}
      >
        <div className="flex flex-col items-center   w-[100%] mds:w-[274px] relative">
          <div className="mds:h-[140px] mds:w-[140px]  w-[88px] h-[88px] relative mds:mt-[15px] object-cover">
            <Image
              alt="ascot team"
              src={element.image}
              layout="fill"
              className="rounded-[75px]"
            />
          </div>

          <div>
            <h3 className="font-[590] text-[18px] text-[#010140] mds:text-[24px] leading-[24px] mt-[13px] ">
              {name[locale]}
            </h3>
          </div>
          <div className=" h-full">
            <h4 className="text-[#36A9E1] text-center"> {element.postion}</h4>
          </div>
        </div>
      </div>
    );
  });
  return (
    <div className=" mt-[1rem] h-[694px] flex flex-col items-center gap-[65px]">
      <div className="skew-y-[3deg] absolute bg-[#010140] opacity-[4%] w-full h-[694px] bottom-[15px] -z-50"></div>
      <div>
        <div className="flex flex-col items-center">
          <h1 className="text-center font-[590] text-[32px] mds:text-[48px] text-[#010140] mt-[54px]">
            {t("title")}
          </h1>
          <hr
            className={`  ${
              locale == "en" ? "bottomborder" : "arabicbottomborder"
            }`}
          ></hr>
          <h2 className="mb-[29px] text-[18px] leading-[26px] font-[400] mt-[36px] w-[90%] text-[#010140] m-auto text-center">
            {t("descrption")}
          </h2>
        </div>

        <div className="max-w-[90rem] m-auto ">
          <div className=" flex flex-row justify-between ">{limitTeamMap}</div>
        </div>

        <div className="flex items-center justify-center ">
          <CustomBtn href={"/about_us/our_team"} txt={t("button")} />
        </div>
      </div>
    </div>
  );
}

export default Team;
